import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectMemberTotalCountQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectMemberTotalCountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, name: string } | null } | null, unfilteredIndirectMembershipsTotalCount?: { __typename?: 'MembershipConnection', totalCount: number } | null, unfilteredDirectMembershipsTotalCount?: { __typename?: 'MembershipConnection', totalCount: number } | null };


export const GetProjectMemberTotalCount = /*#__PURE__*/ gql`
    query GetProjectMemberTotalCount($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      name
    }
  }
  unfilteredIndirectMembershipsTotalCount: indirectMemberships(
    resourceId: $projectId
    page: {first: 0}
  ) {
    totalCount
  }
  unfilteredDirectMembershipsTotalCount: directMemberships(
    resourceId: $projectId
    page: {first: 0}
  ) {
    totalCount
  }
}
    ` as unknown as DocumentNode<GetProjectMemberTotalCountQuery, GetProjectMemberTotalCountQueryVariables>;

          

          export const useGetProjectMemberTotalCountQuery = (options?:QueryHookOptions<GetProjectMemberTotalCountQuery, GetProjectMemberTotalCountQueryVariables>) => useQuery(GetProjectMemberTotalCount, options);

          

          export type GetProjectMemberTotalCountQueryOptions = QueryHookOptions<GetProjectMemberTotalCountQuery, GetProjectMemberTotalCountQueryVariables>;

          

          export const useGetProjectMemberTotalCountLazyQuery = (options?:LazyQueryHookOptions<GetProjectMemberTotalCountQuery, GetProjectMemberTotalCountQueryVariables>) => useLazyQuery(GetProjectMemberTotalCount, options);

          

          export type GetProjectMemberTotalCountQueryResult = ReturnType<typeof useGetProjectMemberTotalCountQuery>;

          
